import React, { useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import { useFormik } from 'formik';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import * as yup from 'yup';
import ContractLayout from './ContractLayout';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import NuDate from '../../../../Components/Utils/NuDate';



function Inspection() {
  const { contractsViewId } = useParams();

         
const location = useLocation();
const currentPage= location.state?.currentPage
const searchQuery= location.state?.searchQuery
const state = location.state;

         const [filter, setFilter] = useState(
             state?.approvalStatus || state?.category ? true : false
           );
             const [showFilterDialog, setShowFilterDialog] = useState(false);

                const {value:status} = useFetchMDIndex
                (`/dropdown/dropdown-details/`,'Status_Schedule',showFilterDialog)
             
                           const { data: user } = UseDropDown(`/user/drop-down`);
             const [filterProps, setFilterProps] = useState({
           
               status:"",
               dateFrom:"",
               dateTo:"",
               assigneeId:"",
             });


           const [params, setParams] = useState({
          //    page: page,
          //    per_page: pageCount,
          //    search:searchQuery||"",
         
          status:"",
          dateFrom:"",
          dateTo:"",
          assigneeId:"",
             approvalStatus:state?.approvalStatus? state.approvalStatus :"",
             category:state?.category? state.category :"",
           });
         
           const clearFilter = ()=> {
             setParams({...params,status:"", dateFrom:"", dateTo:"",assigneeId:"", })
             formik.values.status=""
             formik.values.dateFrom=""
             formik.values.dateTo=""
             formik.values.assigneeId=""
         
         
         
               setFilter(false)
           }
         
           const formik = useFormik({
             enableReinitialize: true,
             initialValues: filterProps,
             validateOnChange: false,
             validateOnBlur: false,
             validationSchema: yup.object({
               // email: yup.string().required('Email is required!'),
             }),
             onSubmit: async (value, { resetForm }) => {
               setParams({...params,status:value.status, dateFrom:value.dateFrom, dateTo:value.dateTo, assigneeId:value.assigneeId, })
               closeFilterDialog();
               setFilter(true)
               setFilterProps({
                 status:"",
                 dateFrom:"",
                 dateTo:"",
                 assigneeId:"",
               });
             }
           })
           const closeFilterDialog = () => {
              setShowFilterDialog(false);
            };

             const { data,getData,dataLoading } = UseGetDataSearch( `/schedules/contract/${contractsViewId}`,params);
              console.log(data,"contractcli");
return (
  <>
  <ContractLayout
   setFilterOpen={setShowFilterDialog}
        ClearFilter={clearFilter}
        newfilter={true}
        isFilter={filter}
        BackAccess={GetAccess("client_management_module")}
  
  >
    <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
    <table className="min-w-full border-separate border-spacing-y-2 text-xs text-left">
      <thead>
        <tr className="text-black font-semibold">
          <th className="px-4 py-2">Ref.</th>
          <th className="px-4 py-2">Contract</th>
          {/* <th className="px-4 py-2">Client</th> */}

          <th className="px-4 py-2">Description</th>
          <th className="px-4 py-2">Location</th>
          <th className="px-4 py-2">Date</th>
          <th className="px-4 py-2">Status</th>
          <th className="px-4 py-2">Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((data) => (
          <tr key={data.id} className=" hover:bg-gray-50 rounded-md shadow-sm">
             <td className="px-4 py-2">
                 <Link to={`/inspection/schedule/view/${data?.id}`} >
                                                                     
                 {data.refNumber}
               </Link>
                                                                     
                 </td>
                   <td className="px-4 py-2">
                   <Link to={`/inspection/schedule/view/${data?.id}`} >
                                                                     
                   {data.contractRefNumber}
                  </Link>
                                                                     
                   </td>
            {/* <td className="px-4 py-2">{data.ref}</td> */}
            {/* <td className="px-4 py-2">{data.clientName}</td> */}
            <td className="px-4 py-2  truncate max-w-[120px] text-ellipsis overflow-hidden">{data.description || "-"}</td>
            <td className="px-4 py-2">{data.location}</td>
            <td className="px-4 py-2">{data.date? (
                       <NuDate
                         value={data?.date}
                         format="DD-MMM-YYYY"
                       />
                     ) : (
                       "N/A"
                     )}</td>
            <td className="px-4 py-2">
              {data.status}
            </td>
            <td className="px-4 py-2 text-gray-500">
              <Link to={`/inspection/schedule/view/${data?.id}`}
                                   state={{
                                     data: data,
                                     from: `/client-management/contracts/inspection/${contractsViewId}`,
                                   }}>
                                         <ViewIcon color="#048178" />

</Link>
</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  </ContractLayout>

{showFilterDialog && (
  <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
      <h2 className="text-xl mb-4">Filter </h2>
      <form onSubmit={formik.handleSubmit}>
        <div className="flex flex-col mb-4">
       <div className="flex justify-between  w-full ">
                                      <NuDate
                                       label="From "
                                       placeholder="dd/mm/yyyy"
                                       formik={formik}
                                       name="dateFrom"
                                       width="w-full"
                                     />
                                      <NuDate
                                       label="To "
                                       placeholder="dd/mm/yyyy"
                                       formik={formik}
                                       name="dateTo"
                                       width="w-full"
                                     />
                                     </div>
                        {/* <MultiSelect
                                      label="Assignee"
                                      Options={user}
                                      formik={formik}
                                      placeholder="Choose"
                                      name="assigneeId"
                                      isRequired={true}
                        
                                      width="w-full"
                                      FixPosition={true}
                                      PortalTarget={false}
                                    /> */}
                      <FormikSelectTwo
                     label="Status"
                     Options={status}
                     formik={formik}
                     placeholder="Choose"
                     name="status"
                     isRequired={true}
       
                     width="w-full "
                   />
        </div>
        <div className="flex justify-end gap-2">
          <CancelButton handleClick={closeFilterDialog} />
          <SubmitButton name="Apply" />
        </div>
      </form>
    </div>
  </div>
)}
</>
)
}

export default Inspection